import { cn } from "@/lib/utils";
import {
    ComponentPropsWithoutRef,
    ElementType,
    ReactNode,
    forwardRef
} from "react";

export interface BoldTextProps {
    as?: ElementType;
    className?: string;
    children?: ReactNode;
}

export const BoldText = forwardRef<
    HTMLElement,
    BoldTextProps & ComponentPropsWithoutRef<ElementType>
>(({ as: Component = "span", className, children, ...props }, ref) => {
    return (
        <Component
            ref={ref}
            className={cn(
                "font-['Pretendard'] text-[20px] font-bold leading-[135%] text-foreground",
                className
            )}
            {...props}
        >
            {children}
        </Component>
    );
});

BoldText.displayName = "BoldText";
